/**
 * A mapping of key to endpoint.
 * @type {Object}
 */
const TRAINING_ENDPOINT = {
  VERIFY_EMAIL: '/users/verify-email',
  CHANGE_PASSWORD: '/users/change-password'
}

export {
  TRAINING_ENDPOINT
}
